<template>
  <Breadcrumbs />
  <DynamicContent
    id="new-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <BrochuresGrid
    :input="{}"
    :pagination="{ limit: 20, offset: 0 }"
    :title="isContentBlockEmpty(content?.introductionBlock) ? $t('new.header') : undefined"
    :impression-source="BrochureImpressionSource.NewOpen"
    :show-load-more="true"
    class="mb-4"
    :infinite-loading="false"
  />
  <Advertisement :display-at="AdDisplayAt.NewBrochuresWeb" class="mb-1" />

  <DynamicContent
    id="new-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>
  <DynamicContent
    id="new-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  ></DynamicContent>
  <DynamicContent
    id="new-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  ></DynamicContent>

</template>

<script setup lang="ts">
import { AdDisplayAt, BrochureImpressionSource, useWebsitePageQuery } from "~/graphql/generated";

const { t } = useI18n();

useSeoMeta({
  title: t("new.title"),
  description: t("new.meta-description"),
  ogDescription: t("new.meta-description"),
});

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/nieuw",
    fr: "/nouveaux",
    nl: "/nieuw",
  },
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped></style>
